import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { GzTitleWebComponent } from '../../../ui/gzTitle';
import { LicenseConstants } from '../../LicenseConstants';
import { FormGroup } from '../../../ui/gzForm/formGroup/form-group';
import { getLocalizedAsset } from '../../../utils/i18n.utils';
import { ProductTypeInformation } from '../../types/ProductTypeInformation';
import { MonthlyProductType } from '../../types/MonthlyProductType';
import { htmlEncode } from '../../../utils/escape.utils';
import { LicenseProductIdEnum } from '@nirvana/shared/license-helper';

interface MonthlyLicenseTrialProductInformation {
  $licenseInfo: HTMLElement;
  $licenseDelegateInfo: HTMLElement;
  endpointSecurityInformation: ProductTypeInformation;
  bitdefenderEdrInformation: ProductTypeInformation;
}

export class LicenseMonthlyLicenseTrialSubFormView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $productDetailsTitle: GzTitleWebComponent;

    productInformation: MonthlyLicenseTrialProductInformation;
  };

  public formGroup: FormGroup = new FormGroup({});

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('#wrapper'),
      $productDetailsTitle: this.shadow.querySelector('#monthly-license-product-details-title'),

      productInformation: {
        $licenseInfo: this.shadow.querySelector('#monthly-license-trial-product-details-license-info-text'),
        $licenseDelegateInfo: this.shadow.querySelector(
          '#monthly-license-trial-product-delegate-details-license-info-text'
        ),
        endpointSecurityInformation: {
          $infoText: this.shadow.querySelector('#monthly-license-trial-product-details-endpoint-security-text'),
          $link: this.shadow.querySelector('#monthly-license-trial-product-details-endpoint-security-link'),
        },
        bitdefenderEdrInformation: {
          $infoText: this.shadow.querySelector('#monthly-license-trial-product-details-bitdefender-edr-text'),
          $link: this.shadow.querySelector('#monthly-license-trial-product-details-bitdefender-edr-link'),
        },
      },
    };

    this.setTranslatedStrings();
  }

  setTranslatedStrings() {
    this.dom.$productDetailsTitle.innerText = this.dependencies.translateFn('Product Details');

    this.dom.productInformation.$licenseInfo.innerText = this.dependencies.translateFn(
      'The company can test the Bitdefender protection for the next 45 days, on maximum 25 endpoints ({endpointSecurityProductType} or {bitdefenderEdrProductType}), 25 mailboxes (Email Security), and 25 mobile devices (Mobile Security).',
      {
        endpointSecurityProductType: this.stringsTranslator.getMonthlyProductType(MonthlyProductType.EndpointSecurity),
        bitdefenderEdrProductType: this.stringsTranslator.getMonthlyProductType(MonthlyProductType.BitdefenderEdr),
      }
    );

    this.dom.productInformation.$licenseDelegateInfo.innerText = this.dependencies.translateFn(
      'The company can also create other companies, with either {endpointSecurityProductType} or {bitdefenderEdrProductType} configuration.',
      {
        endpointSecurityProductType: this.stringsTranslator.getMonthlyProductType(MonthlyProductType.EndpointSecurity),
        bitdefenderEdrProductType: this.stringsTranslator.getMonthlyProductType(MonthlyProductType.BitdefenderEdr),
      }
    );

    this.dom.productInformation.endpointSecurityInformation.$infoText.innerText = this.dependencies.translateFn(
      'With {endpointSecurityProductType}, the company can access all features and add-ons available for {cloudSecurityMspProductName}.',
      {
        endpointSecurityProductType: this.stringsTranslator.getMonthlyProductType(MonthlyProductType.EndpointSecurity),
        cloudSecurityMspProductName: this.stringsTranslator.translateProductId(LicenseProductIdEnum.ProductIdMsp),
      }
    );
    this.dom.productInformation.endpointSecurityInformation.$link.innerHTML = `<span>${htmlEncode(
      this.dependencies.translateFn('Learn more')
    )}</span>`;
    this.dom.productInformation.endpointSecurityInformation.$link.href = getLocalizedAsset<string>(
      LicenseConstants.InfoLinks.CloudSecurityMsp,
      this.dependencies.getUserLanguage()
    );

    this.dom.productInformation.bitdefenderEdrInformation.$infoText.innerText = this.dependencies.translateFn(
      '{bitdefenderEdrProductType} monitors the company`s network to early uncover suspicious activity, and provides the tools to fight-off cyber-attacks. It is suited to coexist with an endpoint security solution from a different vendor.',
      {
        bitdefenderEdrProductType: this.stringsTranslator.getMonthlyProductType(MonthlyProductType.BitdefenderEdr),
      }
    );
    this.dom.productInformation.bitdefenderEdrInformation.$link.innerHTML = `<span>${htmlEncode(
      this.dependencies.translateFn('Learn more')
    )}</span>`;
    this.dom.productInformation.bitdefenderEdrInformation.$link.href = LicenseConstants.InfoLinks.BitdefenderEdr;
  }

  buildSuccessView(data: any) {}

  buildErrorView(error: Error) {}
}
